export const environment = {
  production: true,
  envName: 'prod',
  googleMapsApiKey: 'AIzaSyBDFeHv4826TfRp3nUVZz8BdF_mzMz3FZI',
  apiDomain: 'https://sherlock.aerobotics.com/'
};
